import { Stack } from '@mui/material';
import { type ReactNode } from 'react';

import { Text } from 'common';

interface FlowTemplatePreviewPanelGroupProps {
  children: ReactNode;
  title: string;
}

export function FlowTemplatePreviewPanelGroup(props: FlowTemplatePreviewPanelGroupProps) {
  const { children, title } = props;

  return (
    <Stack gap={1}>
      <Text variant="heading5" color="text.secondary" bold sx={{ textTransform: 'uppercase' }}>
        {title}
      </Text>
      {children}
    </Stack>
  );
}
